import React from 'react'
import { MainHeading, NoticeLinks, TermsConditionsContent } from '../../components'
import { Col, Container, Row } from 'react-bootstrap'

const TermsConditions = () => {
  return (
    <div className='terms-condition-main'>
        <Container>
                <MainHeading title="Website terms and conditions of use" showshare={false} />
                <div className='content-pages-wrapper'>
                    <Row>
                        <Col md={8} sm={12} className='order-md-1 order-2'>
                            <TermsConditionsContent/>
                        </Col>
                        <Col md={4} sm={12}  className='order-md-2 order-1'>
                            <NoticeLinks/>
                        </Col>
                    </Row>
                </div>
            </Container>
    </div>
  )
}

export default TermsConditions
